import { Reducer } from "redux";
import { Action, ActionType } from "../actions";
import { RequestsData } from "../state/RequestsData";
import { areObjsEqualSimple } from '../../utils/MiscUtils';

const updateRequests: Reducer<RequestsData> = (state: RequestsData = new RequestsData(), action: Action<ActionType, RequestsData>) => {
  switch (action.type) {
    case ActionType.REQUEST_START:
      state.requests.push({ abortController: action.data });
      return { ...state };
    case ActionType.REQUEST_END:
      const filtredRequests = state.requests.filter((el: any) => !areObjsEqualSimple(el.abortController, action.data));
      if (!filtredRequests.length) {
      }
      return { ...state, requests: filtredRequests };
    default:
      return state;
  }
}

export default updateRequests;